module.exports = __webpack_public_path__ + "media/images/icon-external-971c3db09346c9127075a669ab124899.svg";